import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const getInitialAge = () => {
  try {
    const raw = localStorage.getItem('userAge');
    if (!raw || raw === 'null' || raw === 'undefined') return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export default new Vuex.Store({
  state: {
    userAge: getInitialAge(),
  },
  getters: {
    getUserAge: state => state.userAge,
  },
  mutations: {
    setUserAge(state, payload) {
      state.userAge = payload;
      if (!payload) {
        localStorage.removeItem('userAge');
      } else {
        localStorage.setItem('userAge', JSON.stringify(payload));
      }
    },
    clearUserAge(state) {
      state.userAge = null;
      localStorage.removeItem('userAge');
    }
  },
  actions: {
    saveUserAge({ commit }, userAge) {
      commit('setUserAge', userAge);
    },
    clearUserAge({ commit }) {
      commit('clearUserAge');
    }
  },
  modules: {},
});